import moment from "moment";
import Api from "./Api";

export interface Login {
  email: string;
  password: string;
}

export interface ApiResponse {
  status: boolean;
  data: string;
  message: string;
}

const ApiService = {
  async login(data: Login): Promise<ApiResponse> {
    return Api.post<ApiResponse>("/users/login", data);
  },
  async createUser(data: any): Promise<any> {
    return Api.post<ApiResponse>("/users/create", data);
  },
  async getProfile(): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users?date=${moment(new Date()).format('yyyy-MM-DD')}`);
  },
  async getUserProfile(): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users/profile`);
  },
  async getChallenges(): Promise<any> {
    return Api.get<ApiResponse>("/users/challenges")
  },
  async dailyCheckIn(data: any): Promise<any> {
    return Api.post<ApiResponse>("/api/v2/users/daily_checkin", data);
  },
  async editDailyCheckIn(data: any): Promise<any> {
    return Api.put<ApiResponse>("users/daily_checkin", data);
  },
  async getMessages(): Promise<any> {
    return Api.get<ApiResponse>("users/contacts");
  },
  async getMyJourney(page: number = 1, limit: number = 10): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users/myjourney?page=${page}&limit=${limit}`);
  },
  async updateUserDetails(data: any): Promise<any> {
    return Api.put<ApiResponse>("users/update", data);
  },
  async updateUserPassword(data: any): Promise<any> {
    return Api.post<ApiResponse>("users/forgot_password", data);
  },
  async getMoodRingData(month: any): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users/moodRings/${month}`);
  },
  async answerText(data: any): Promise<any> {
    return Api.post<ApiResponse>("/api/v2/users/challenges/attempt", data);
  },
  async getQuizById(data: any, page: number = 1, limit: number = 10): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users/challenges/${data}/feeds?page=${page}&limit=${limit}`);
  },
  async getChallengeById(data: any): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users/challenge/${data}`);
  },
  async getAvailableChallenges(): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users/challenges`);
  },
  async getMessagesById(data: any): Promise<any> {
    return Api.get<ApiResponse>(`users/messages/${data}`);
  },
  async readMessagesById(id: any): Promise<any> {
    return Api.put<ApiResponse>(`users/messages/read/${id}`);
  },
  async sendMessage(data: any): Promise<any> {
    return Api.post<ApiResponse>("users/send/messages" ,data);
  },
  async getFeeds(): Promise<any> {
    return Api.get<ApiResponse>("users/feeds");
  },
  async sendResetEmail(data: any): Promise<any> {
    return Api.get<ApiResponse>(`send-forgot-password-email?email=${data.email}`);
  },
  async checkMessage(): Promise<any> {
    return Api.get<ApiResponse>("users/check_message_status");
  },
  async changePassword(data: any): Promise<any> {
    return Api.post<ApiResponse>("/api/v2/users/change-password", data);
  },
  async getPoints(page: number = 1, pageSize: number = 10): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users/points?page=${page}&limit=${pageSize}`);
  },
  async getPrizes(): Promise<any> {
    return Api.get<ApiResponse>("/api/v2/users/prizes/all");
  },
  async getClaims(page: number = 1, pageSize: number = 10): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users/claims?page=${page}&limit=${pageSize}`);
  },
  async claimPrize(data: any): Promise<any> {
    return Api.post<ApiResponse>("/api/v2/users/prizes/claim", data);
  },
  async getPrizeById(id: string): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users/prizes/${id}`);
  },
  async getLeaderboard(): Promise<any> {
    return Api.get<ApiResponse>(`/api/v2/users/leaderboard`);
  },

};

export default ApiService;
